<script lang="ts">
    import { tgettext } from 'hydria/services/gettext'

    import { INFORMATION_PAGE_TYPES } from 'admin/admin_constants'

    import SimpleListingWithPagination from 'hydria/components/SimpleListings/SimpleListingWithPagination.svelte'

    const singular = 'information'
    const plural = 'informations'
    const baseUrl = '/informations'

    const pageTitle = tgettext('Informations')
    const createButtonText = tgettext('Ajouter un texte d’information')

    const pageTypeIndex = Object.fromEntries(INFORMATION_PAGE_TYPES.map((inf) => [inf.id, inf.name]))

    const extraLgFields = [
        {
            id: 'page',
            name: tgettext('Page'),
            empty: '–',
            resolve: (value: string, lg: string) => {
                return pageTypeIndex[value] ? pageTypeIndex[value] : value
            },
        },
    ]

    interface Props {
        route: any
    }

    let { route }: Props = $props()
</script>

<SimpleListingWithPagination {route} {singular} {plural} {baseUrl} {pageTitle} {createButtonText} {extraLgFields} />
